module.exports = __webpack_public_path__ + "static/media/digital-work4.c2a547db.jpg";